const WrappedCheckIcon = ({ color, height = '32px', width = '32px' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="wrapped-check"
  >
    <path
      d="M9.18976 21.4309C10.812 23.3389 12.9802 24.703 15.4018 25.339C17.8234 25.9751 20.3817 25.8525 22.7315 24.9879C25.0813 24.1232 27.1093 22.5581 28.5419 20.5038C29.9745 18.4495 30.7426 16.0049 30.7426 13.5C30.7426 10.9951 29.9745 8.55055 28.5419 6.49625C27.1093 4.44194 25.0813 2.87683 22.7315 2.01218C20.3817 1.14753 17.8234 1.02497 15.4018 1.66104C12.9802 2.29711 10.812 3.66119 9.18976 5.56915"
      stroke={color}
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M11.6033 6.46254C12.9895 5.09782 14.748 4.17338 16.6577 3.80535C18.5674 3.43731 20.5432 3.64209 22.337 4.39396C24.1307 5.14583 25.6624 6.41125 26.7396 8.03129C27.8168 9.65132 28.3915 11.5537 28.3915 13.4995C28.3915 15.4453 27.8168 17.3476 26.7396 18.9677C25.6624 20.5877 24.1307 21.8531 22.337 22.605C20.5432 23.3569 18.5674 23.5616 16.6577 23.1936C14.748 22.8256 12.9895 21.9011 11.6033 20.5364"
      stroke={color}
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M12.9407 14.6365L17.6345 18.1727L24.2631 8.89807"
      stroke={color}
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M3.04926 10.3361H10.1088"
      stroke={color}
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M3.04926 16.0777H10.1088"
      stroke={color}
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M1.26019 13.2069H10.1088"
      stroke={color}
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export default WrappedCheckIcon;
